// ═══════════════════════════════════════════════════════════════
// frontend/src/pages/ProductList.tsx
// ═══════════════════════════════════════════════════════════════

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { ProductApi } from "../lib/api";
import { Link } from "react-router-dom";

export default function ProductList() {
  const queryClient = useQueryClient();
  const { data: products, isLoading, error } = useQuery({ queryKey: ["products"], queryFn: () => ProductApi.list() });

  if (isLoading) return <p className="text-gray-500">Loading products...</p>;
  if (error) return <p className="text-red-500">Error: {(error as Error).message}</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Products</h1>
        <Link to="/products/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
          + New Product
        </Link>
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Name</th>
              <th className="text-left px-4 py-3 font-medium text-gray-600">Type</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">List Price</th>
              <th className="text-right px-4 py-3 font-medium text-gray-600">Cost</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {products?.map((p: any) => (
              <tr key={p.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{p.name}</td>
                <td className="px-4 py-3">
                  <span className="px-2 py-0.5 rounded-full text-xs bg-gray-100">{p.type}</span>
                </td>
                <td className="px-4 py-3 text-right">${p.list_price?.toFixed(2)}</td>
                <td className="px-4 py-3 text-right text-gray-500">${p.standard_price?.toFixed(2)}</td>
              </tr>
            ))}
            {(!products || products.length === 0) && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400">No products found</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
